import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { deadlineInfo, formatCzDate } from "../utils/deliveryDeadline";

// "Doručit do" reminder: contractual delivery deadline of a machine (2 months after signing by default).

// Inline badge: "Doručit do 14. 12. 2026 · zbývá 9 dní".
export function DeliveryDeadlineBadge({ deadline, deliveredAt, compact = false }) {
  const info = deadlineInfo(deadline, deliveredAt);
  if (info.state === "none" && compact) return null;
  return (
    <span
      title="Smluvní termín dodání (výchozí: 2 měsíce od podpisu smlouvy)"
      style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 10px", borderRadius: "999px", fontSize: "13px", fontWeight: 600, color: info.color, background: info.bg, whiteSpace: compact ? "nowrap" : "normal", maxWidth: "100%", boxSizing: "border-box" }}
    >
      <CalendarClock size={14} aria-hidden="true" />
      {deadline && !compact ? `Doručit do ${formatCzDate(deadline)} · ` : ""}{info.label}
    </span>
  );
}

// Dashboard card: machines not delivered yet, nearest deadline first.
export function UpcomingDeliveries({ items = [] }) {
  return (
    <div style={{ backgroundColor: "#FFF", borderRadius: "12px", border: "1px solid #E0E0E0", padding: "20px" }}>
      <h2 style={{ fontSize: "18px", fontWeight: 600, color: "#333", margin: "0 0 16px", display: "flex", alignItems: "center", gap: "8px" }}>
        <CalendarClock size={20} color="#E53935" /> Termíny dodání
      </h2>
      {items.length === 0 ? (
        <p style={{ color: "#999", margin: 0, fontSize: "14px" }}>Žádný nedoručený trenažér s termínem dodání.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {items.map((m) => (
            <Link key={m.id} to={`/machines/${m.id}`} style={{ textDecoration: "none", color: "inherit" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", padding: "10px 12px", borderRadius: "10px", background: "#F9F9F9", flexWrap: "wrap" }}>
                <div style={{ minWidth: 0, flex: "1 1 160px" }}>
                  <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#333" }}>{m.model_type} {m.serial_number}</p>
                  <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#777", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {m.customer_name || "Bez zákazníka"} · do {formatCzDate(m.delivery_deadline)}
                  </p>
                </div>
                <DeliveryDeadlineBadge deadline={m.delivery_deadline} compact />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
